import Vue from 'vue'
import { asyncRoutes, constantRoutes, approvalRoutes, adminRoutes } from '@/router'
import { getRolePermission } from '@/api/system/role'
import { cloneDeep } from 'lodash'
import Layout from '@/layout'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
  menuList: [], // 路由权限
  buttonList: [], // 按钮权限
  tabList: [] // tab权限
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_PERMISSION: (state, { buttonList, menuList, tabList }) => {
    state.menuList = menuList
    state.buttonList = buttonList
    state.tabList = tabList
  }
}

const actions = {
  async generateRoutes({ commit, rootState }) {
    const roleIds = []
    if (rootState?.user?.userInfo?.roles) {
      rootState.user.userInfo.roles.map((item) => {
        // 移除禁用的权限
        if (item.enable !== 0) {
          roleIds.push(item.id)
        }
      })
    }
    const params = {
      type: 1
    }
    const accountType = rootState?.user?.userInfo.accountType
    params.isAdmin = accountType
    if (roleIds.length !== 0) {
      params.roleIds = roleIds
    }
    let dynamicRoutes = []
    const res = await getRolePermission(params)
    if (res.code === 200 && res.data) {
      commit('SET_PERMISSION', res.data)
    }
    const menuList = res?.data?.menuList?.map((item) => item.code) || []
    const dealRoute = (arr) => {
      const list = []
      arr.map((item) => {
        if ((item.permissionCode && menuList.includes(item.permissionCode)) || !item.permissionCode) {
          list.push(item)
          if (item.component && item.component.name === 'Layout') {
            item.component = Layout
          }
          if (item.children) {
            item.children = dealRoute(item.children)
          }
        }
      })
      return list
    }
    const newRoutes = dealRoute(cloneDeep(asyncRoutes))
    // 专业版内嵌页面
    dynamicRoutes = newRoutes
    if (Vue.prototype.$isInFrame) {
      dynamicRoutes = dynamicRoutes.concat(approvalRoutes)
    } else {
      dynamicRoutes = dynamicRoutes.concat(approvalRoutes)
    }
    // 超级管理员
    console.log('accountType', accountType)
    if (accountType === 0) {
      dynamicRoutes = dynamicRoutes.concat(dealRoute(cloneDeep(adminRoutes)))
    }
    // 添加404页面
    // dynamicRoutes = dynamicRoutes.concat(approvalRoutes)
    commit('SET_ROUTES', dynamicRoutes || [])
    return Promise.resolve(dynamicRoutes || [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
